// extracted by mini-css-extract-plugin
module.exports = {"game":"styles_game__22eFF","header":"styles_header__138Nd","score":"styles_score__2RNgU"};